import axios from 'axios'
const API = process.env.REACT_APP_API_BASE

export const registerForMatch = async (matchId, body = {}, token) => {
  const resp = await axios.post(`${API}/matches/${matchId}/register`, body, { headers: { Authorization: `Bearer ${token}` } })
  return resp.data
}

export const unregister = async (matchId, token) => {
  const resp = await axios.post(`${API}/matches/${matchId}/unregister`, {}, { headers: { Authorization: `Bearer ${token}` } })
  return resp.data
}

export const getRegistrationsForMatch = async (matchId, token) => {
  const resp = await axios.get(`${API}/matches/${matchId}/registrations`, { headers: { Authorization: `Bearer ${token}` } })
  return resp.data
}

export const getMyRegistrations = async (token) => {
  const resp = await axios.get(`${API}/registrations/me`, { headers: { Authorization: `Bearer ${token}` } })
  return resp.data
}
